import { Container } from '@/components/layout/Container';
import { PRIMARY_NAV_HEIGHT } from '@/components/navigation/PrimaryNavigation';
import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import MasterTemplate from './MasterTemplate';

const PageWrapper = styled.section`
  margin-top: ${remCalc(PRIMARY_NAV_HEIGHT)};
  ${paddingY(40)};

  ${mediaBreakpointUp('desktop')} {
    ${paddingY(80)};
  }

  > ${Container} {
    max-width: ${remCalc(850)};
  }
`;

const LegalTemplate: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MasterTemplate showAnnouncement={false}>
      <PageWrapper>{children}</PageWrapper>
    </MasterTemplate>
  );
};

export default LegalTemplate;
